import { TableCell } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled(TableCell)`
  transition: 3ms;
  background: #fff;
  position: absolute;
  right: 0;
  margin-right: ${({ size }) => (size !== 'default' ? '0.2rem' : '4rem')};
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 999;
  padding: ${({ size }) =>
    size !== 'default' ? '0.2rem ' : '1.2rem 2rem !important'};
  border: transparent;

  button {
    margin: 0 0.2rem;
  }

  svg {
    font-size: 1.9rem;

    :hover {
      color: #000;
    }
  }
`;
